import React from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params';
import toast, { ToastBar, Toaster } from "react-hot-toast";

import AllLaunches from "./container/board";
import CreateEthPump from "./container/create.tsx";
import NotFound from "./container/NotFound";
import BuyPage from "./container/BuyPage";
import Profile from "./container/Profile.tsx";
import ReferralPage from './container/Referral.tsx';

import './index.css';
import Faq from "./container/Faq";
import About from "./container/About";
import { ThemeProvider } from './context/ThemeContext';

import { createAppKit } from '@reown/appkit/react'
import { bsc } from '@reown/appkit/networks'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { wagmiAdapter, projectId } from "./config";


const queryClient = new QueryClient()
const currentUrl = window.location.origin;

const metadata = {
  name: 'DogWifHair',
  description: 'DogWifHair Wagmi',
  url: currentUrl,
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

createAppKit({
  adapters: [wagmiAdapter],
  networks: [bsc],
  projectId,
  metadata,
  features: {
    analytics: true,
    swaps: false,
    socials: false,
    email: false,
  },
  themeVariables: {
    "--w3m-accent": "#00BB7F",
    "--w3m-font-family": "Satoshi, -apple-system, BlinkMacSyst",
    "--w3m-font-size-master": "12px",
  },
})

const App = () => {
  return (
    <WagmiProvider reconnectOnMount config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Router>
            <QueryParamProvider>
              <div className="mt-4">
                <Toaster
                  position="top-right"
                  reverseOrder={true}
                  toastOptions={{ duration: 5000 }}
                >
                  {t => (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => toast.dismiss(t.id)}
                    >
                      <ToastBar onClick={() => alert(1)} toast={t} />
                    </div>
                  )}
                </Toaster>
                <Switch>
                  <Route exact path="/">
                    <AllLaunches />
                  </Route>
                  <Route exact path="/dashboard">
                    <AllLaunches />
                  </Route>
                  <Route exact path="/create">
                    <CreateEthPump />
                  </Route>
                  <Route exact path="/Buy">
                    <BuyPage />
                  </Route>
                  <Route exact path="/profile">
                    <Profile />
                  </Route>
                  <Route exact path="/faq">
                    <Faq />
                  </Route>
                  <Route exact path="/about">
                    <About />
                  </Route>
                  <Route exact path="/referral">
                    <ReferralPage />
                  </Route>
                  <Route exact path="/NotFound">
                    <NotFound />
                  </Route>
                </Switch>
              </div>
            </QueryParamProvider>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
